<template>
<div class="chapter">
<div class="inner_page">
<p><a id="epi"></a></p>
<div class="epiv">
    What did I know, what did I know of love’s austere and lonely offices?
  </div>
<div class="eps">
<div>
       <br/>
</div>—Robert Hayden “Those Winter Sundays”
  </div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// john_9781571318169_oeb_epi_r1.vue?5c5e81f6